// extracted by mini-css-extract-plugin
export default {"links":"Top_links__zneBg"};